export default __webpack_public_path__ + "static/media/480_private01-en-web.68f163b2.png";